<template>
  <div class="page">
    <van-swipe class="my-swipe" :autoplay="3000" indicator-color="#0C68A9" @change="onChange">
      <van-swipe-item v-for="(item,index) in dateInfo.img" :key="index" @click="handleImage(item.redirect_url)">
        <img  class="slider-img" :src="cdnUrl + item" />
      </van-swipe-item>
      <template #indicator v-if="dateInfo.img.length>1">
        <div class="custom-indicator">
          <span v-for="(item,index) in dateInfo.img" :key="index" class="custom-item" :class="index== current ? 'cus-item-active' : ''"></span>
        </div>
      </template>
    </van-swipe>
    <div class="item_box">
        <div class="poly-tip">
            <span class="iconfont icon-a-bianzu18 icon-col"></span>
            <span>{{ dateInfo.title }}</span>
        </div>
        <!-- <div class="name_box">
            <img class="name_icon" :src="cdnUrl+'eppendorf/title_icon.png'" alt="">
            <div class="name">{{dateInfo.title}}</div>
        </div> -->  
    </div>
    <div class="title_box">
        <div class="line"></div>
        <div class="title">参数</div>
    </div>
    <div class="box">
        <div class="item" v-if="dateInfo.max_vol||dateInfo.max_rcf">
            <div class="items" v-if="dateInfo.max_vol">
                <div class="label_box">
                    <img class="icon" :src="cdnUrl+'eppendorf/att_icon1.png'" alt="">
                    <div class="label">最大容量(mL)</div>
                </div>
                <div class="value">{{dateInfo.max_vol}}</div>
            </div>
           <div class="items" v-if="dateInfo.max_rcf">
                <div class="label_box">
                    <img class="icon" :src="cdnUrl+'eppendorf/att_icon2.png'" alt="">
                    <div class="label">最大RCF(xg)</div>
                </div>
                <div class="value">{{dateInfo.max_rcf}}</div>
            </div>
        </div>
        <div class="item">
            <div class="items" v-if="dateInfo.applicable_model">
                <div class="label_box">
                    <img class="icon" :src="cdnUrl+'eppendorf/att_icon3.png'" alt="">
                    <div class="label">适配机型</div>
                </div>
                <div class="value">{{dateInfo.applicable_model}}</div>
            </div>
           <div class="items">
                <div class="label_box">
                    <img class="icon" :src="cdnUrl+'eppendorf/att_icon4.png'" alt="">
                    <div class="label">包含耗材</div>
                </div>
                <div class="value">{{dateInfo.has_consumables==1?'包含':'不包含'}}</div>
            </div>
        </div>
        <div class="item" v-if="dateInfo.k_factor||dateInfo.applicable_consumables_vol">
            <div class="items" v-if="dateInfo.k_factor">
                <div class="label_box">
                    <img class="icon" :src="cdnUrl+'eppendorf/att_icon5.png'" alt="">
                    <div class="label"> K因子</div>
                </div>
                <div class="value">{{dateInfo.k_factor}}</div>
            </div>
           <div class="items" v-if="dateInfo.applicable_consumables_vol">
                <div class="label_box">
                    <img class="icon" :src="cdnUrl+'eppendorf/att_icon6.png'" alt="">
                    <div class="label">适配耗材体积(mL)</div>
                </div>
                <div class="value">{{dateInfo.applicable_consumables_vol}}</div>
            </div>
        </div>
        <div class="item" v-if="dateInfo.number">
            <div class="items">
                <div class="label_box">
                    <img class="icon" :src="cdnUrl+'eppendorf/att_icon7.png'" alt="">
                    <div class="label">转子货号</div>
                </div>
                <div class="value">{{dateInfo.number}}</div>
            </div>
        </div>
        <div class="item" v-if="dateInfo.product_application">
            <div class="items">
                <div class="label_box">
                    <img class="icon" :src="cdnUrl+'eppendorf/att_icon8.png'" alt="">
                    <div class="label">产品应用</div>
                </div>
                <div class="value">{{dateInfo.product_application}}</div>
            </div>
        </div>
    </div>
    <div class="title_box" v-if="dateInfo.pdfs.length>0">
        <div class="line"></div>
        <div class="title">PDF</div>
    </div>
    <div class="list1">
        <div class="item1" v-for="(item,index) in dateInfo.pdfs" :key="index" @click="previewPdf()">
            <img class="img1" :src="cdnUrl + item.cover" alt="">
            <div class="bottom"></div>
        </div>
    </div>
    <div class="title_box" v-if="dateInfo.medias.length>0">
        <div class="line"></div>
        <div class="title">视频</div>
    </div>
    <div class="list2">
        <div class="item2" v-for="(item,index) in dateInfo.medias" :key="index" @click="goVideoDetail(item)"> 
            <img class="video_img" :src="cdnUrl + JSON.parse(item.img_url)[0]" alt="">
            <img class="icon" :src="cdnUrl+'eppendorf/play_icon.png'" alt="">
        </div>
    </div>
    <button class="btn" @click="getFormInfo()" v-if="dateInfo.form_id">咨询详情</button>
    <!-- 表单 -->
    <customer-form ref="customerForm" :id="dateInfo.form_id" :type="'rotor'" :type_id="id"></customer-form>
    <video-play ref="videoPlay"></video-play>
   </div>
</template>

<script>
import { getRotorDetails } from '@/api/rotor'
import { getForm } from '@/api/polymerize';
import { recordVideo, recordPdf } from '@/api/product'
import eppBanner from '@/components/eppBanner'
import customerForm from '@/components/form';
import videoPlay from '@/components/videoPlay'
import { action } from '@/api/newSpecial'
export default {
  components: {
    eppBanner,
    customerForm,
    videoPlay
  },
  data() {
    return {
    current: 0,
      cdnUrl: this.$config.baseUrl.cdnUrl,
      dateInfo:{},
      id:this.$route.query.id,
      applyFormDataList: [], // 表单列表
      applyFormItem: {},
    }
  },
  created() {
    this.getDetail()
  },
  methods: {
    getDetail(){
        getRotorDetails({id:this.id}).then(res => {
            this.dateInfo = res.data
            action({model:'rotor',model_id:this.id,action:'view'})
        })
    },
    getFormInfo() {
        this.$refs.customerForm.showApplyForm()
        // getForm({id: this.dateInfo.form_id}).then(res => {
        //     this.applyFormDataList = res.data.keys
        //     this.addPhoneCode()
        //     this.$refs.customerForm.showApplyForm()
        // })
    },
    addPhoneCode() { // 添加验证码
        this.applyFormDataList.forEach(item => {
            if (item.type === 2) {
                this.applyFormItem[item.field] = []
            } else {
                this.applyFormItem[item.field] = ''
            }
        })
        let moIndex = ''
        this.applyFormDataList.filter((value,index) => {
            if (value.field == 'mobile') {
                moIndex = index
            }
            if(value.field == 'code') {
                moIndex = false
            }
        })
        if (moIndex) {
            let moblie = {
                field: 'code',
                required: 1,
                title: '验证码',
                type: 3,
                value: "",
                placeholder: "请输入验证码"
            }
            this.applyFormDataList.splice(moIndex+1, 0, moblie)
        }
    },
    handleSon() {
        // this.user_exists = true
    },
    goVideoDetail(item){
        this.recordVideoPort(item.id)
        this.$refs.videoPlay.dplayerOption(`${this.cdnUrl + JSON.parse(item.video_url)[0]}`)
    },
    previewPdf (id) {
        window.location.href = `${this.cdnUrl.pro}/pageTurnings/index.html?id=${id}`
        this.recordPDFPort(id)
    },
    // 记录PDF浏览记录
    recordPDFPort (id) {
        recordPdf({ id }).then(res => {
            console.log(res)
        }).catch(err => {
            console.log('记录pdf浏览记录失败', err)
        })
    },
    recordVideoPort (videoId) {
        recordVideo({ id: videoId }).then(res => {
            // console.log(res)
        }).catch(err => {
            console.log('记录视频浏览记录失败', err)
        })
    },
  }
}
</script>

<style lang="scss" scoped>
.page{
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #F8F8F8;
    .my-swipe {
        width: 100%;
        height: rem(245);
        .slider-img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }
    .custom-indicator {
        position: absolute;
        right: 5px;
        bottom: 5px;
        .custom-item {
            display: inline-block;
            width: rem(7);
            height: rem(7);
            margin-right: 3px;
            background: #abd8e3;
            border-radius: 50%;
        }
        .cus-item-active {
            width: rem(19);
            background: #67c3d9;
            border-radius: 5px;
        }
    }
    .item_box{
        width: rem(344);
        margin-top: rem(14);
        .poly-tip {
            font-weight: bold;
            display: inline-block;
            // margin: 0 rem(14) rem(14) rem(14);
            // margin-top: rem(11);
            padding-bottom: rem(4);
            font-size: 17px;
            color: $poly-color;
            border-bottom: 1px solid $poly-color;
            span:nth-child(2) {
                margin-left: rem(7);
                
            }
            .icon-col {
                color: $poly-color;
            }
        }
        .name_box{
            width: rem(144);
            height: rem(25);
            display: flex;
            align-items: center;
            position: relative;
            border-bottom: rem(1) solid #0C68A9;
            .name_icon{
                width: rem(14);
                height: rem(14);
            }
            .name{
                height: rem(22);
                font-weight: bold;
                font-size: rem(16);
                color: #0C68A9;
                line-height: rem(22);
                margin-left: rem(7);
            }
        }
    }
    .title_box{
        width: rem(344);
        height: rem(40);
        display: flex;
        align-items: center;
        margin-top: rem(20);
        .line{
             width: rem(4);
            height: rem(31);
            background: #6CC5DB;
        }
        .title{
            font-weight: bold;
            font-size: rem(14);
            color: #333333;
            margin-left: rem(8);
        }
    }
    .box{
        width: rem(344);
        // height: rem(369);
        background: linear-gradient( 134deg, #F8FEFF 0%, #FFFFFF 100%);
        box-shadow: 0px 2px 8px 0px rgba(28,106,121,0.16);
        border-radius: rem(4);
        border: 1px solid rgba(89,193,214,0.3);
        backdrop-filter: blur(7px);
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: rem(20);
        .item{
            width: rem(320);
            padding: rem(10);
            box-sizing: border-box;
            display: flex;
            justify-content: space-between;
            border-bottom: rem(1) solid #D8D8D8;
            .items{
                flex: 1;
                min-width: 50%;
                flex-shrink: 0;
                .label_box{
                    display: flex;
                    align-items: center;
                    .icon{
                        width: rem(20);
                        height: rem(20);
                    }
                    .label{
                        font-weight: bold;
                        font-size: rem(14);
                        color: #0C68A9;
                        margin-left: rem(7);
                    }
                }
                .value{
                    font-size: rem(12);
                    color: #666666;
                    margin-top: rem(4);
                    word-wrap: break-word;
                }
            }
        }
        .item:last-child{
            border-bottom: unset;
        }
    }
    .list1{
        width: rem(344);
        display: flex;
        flex-wrap: wrap;
        margin-top: rem(16);
        padding-left: rem(8);
        .item1{
            width: rem(100);
            height: rem(135);
            margin-right: rem(16);
            display: flex;
            flex-direction: column;
            align-items: center;
            .img1{
                width: rem(98);
                height: rem(128);
            }
            .bottom{
                width: rem(100);
                height: rem(8);
                background: #FFFFFF;
                box-shadow: 0px -2px 8px -1px #2C2C2C; 
            }
        }
        .item1:nth-child(3n){
            margin-right: 0;
        }
    }
    .list2{
        width: rem(344);
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        margin-top: rem(16);
        .item2{
            width: rem(163);
            height: rem(92);
            border-radius: rem(4);
            position: relative;
            margin-bottom: rem(10);
            .video_img{
                width: rem(163);
                height: rem(92);
                border-radius: rem(4);
            }
            .icon{
                width: rem(30);
                height: rem(30);
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%,-50%);
            }
        }
    }
    .btn{
        width: rem(169);
        height: rem(40);
        background: #6CC5DB;
        border-radius: rem(2);
        border: unset;
        font-weight: bold;
        font-size: (16);
        color: #FFFFFF;
        margin-top: rem(10);
        margin-bottom: rem(50);
    }
}
</style>